// extracted by mini-css-extract-plugin
export default {"PrimerLink":"DirectoryRow-module__PrimerLink--Pt1d6","Box":"DirectoryRow-module__Box--NOziH","Octicon":"DirectoryRow-module__Octicon--S5rCK"};